import script from "./LogoInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogoInput.vue?vue&type=script&lang=ts&setup=true"

import "./LogoInput.vue?vue&type=style&index=0&id=fb6b520e&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb6b520e"]])

export default __exports__